import Backbone from "backbone";
import * as preact from "preact";

import BookCoverConnector from "./BookCoverConnector";

export interface PublicLibraryListViewOptions {
  models: any;
  bookFilter?: (bookModel: any) => boolean;
  showNoTextsMessage?: boolean;
  rendered?: () => void;
}

export default class PublicLibraryListView extends Backbone.View {
  options: PublicLibraryListViewOptions;
  deletedBooks: Record<string, any>;
  renderTimer: ReturnType<typeof setTimeout> | undefined;

  constructor(options: PublicLibraryListViewOptions & Backbone.ViewOptions) {
    super(options);
    this.options = options;
    this.deletedBooks = {};

    this.listenTo(this.collection, "reset", () => {
      this.renderOnce();
    });

    this.renderWithCallback(() => {
      if (this.options.rendered) {
        this.options.rendered();
      }
    });
  }

  renderOnce() {
    clearTimeout(this.renderTimer);
    this.renderTimer = setTimeout(() => {
      this.renderWithCallback(() => {});
    }, 0);
  }

  renderWithCallback(callback: () => void) {
    const filteredBooks: any[] = [];

    this.collection.each((bookModel: any) => {
      if (
        !bookModel.has("parent") &&
        (!this.options.bookFilter || this.options.bookFilter(bookModel))
      ) {
        filteredBooks.push(bookModel);
      }
    });

    preact.render(
      <div>
        {filteredBooks.length === 0 && this.options.showNoTextsMessage ? (
          <p style="text-align:center;margin-top:20px">No texts found</p>
        ) : (
          filteredBooks.map((book) => (
            <BookCoverConnector
              book={book}
              userID={this.options.models.user.id}
            />
          ))
        )}
      </div>,
      this.$el[0]
    );

    if (callback) callback();
  }

  render(): this {
    this.renderWithCallback(() => {});
    return this;
  }
}
